import React from 'react';
import Placeholder from 'components/consumer/Placeholder';
import classNames from 'classnames';
import PDPChooseYourOptionsPlaceholder from '../PDPChooseYourOptions/PDPChooseYourOptionsPlaceholder';
import PDPProtectionPlanSelectorPlaceholder from '../PDPProtectionPlanSelector/PDPProtectionPlanSelectorPlaceholder';
import PDPAddToBagSectionPlaceholder from '../PDPAddToBagSection/PDPAddToBagSectionPlaceholder';
import PDPSellingAttributesPlaceholder from '../PDPSellingAttributes/PDPSellingAttributesPlaceholder';
import PDPProductDescriptionPlaceholder from '../PDPProductDescription/PDPProductDescriptionPlaceholder';

const PDPMobilePlaceholder = ({ className: parentClassName }) => (
  <div className={classNames('flex flex-col flex lg:hidden', parentClassName)}>
    {/* TODO: Add PDPBreadCrumbs placeholder  */}
    <div className="pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw]">
      <Placeholder
        className="my-1.5"
        loading
        type="rect"
        style={{ width: '200px', height: '24px' }}
      />
      <Placeholder
        className="mb-4"
        loading
        type="rect"
        style={{ width: '180px', height: '18px' }}
      />
      <Placeholder
        className="mb-1.5"
        loading
        type="rect"
        style={{ width: '72px', height: '24px' }}
      />
      <Placeholder
        className="mb-3"
        loading
        type="rect"
        style={{ width: '180px', height: '18px' }}
      />
    </div>
    <Placeholder
      className="mb-1.5"
      loading
      type="rect"
      style={{ width: '100vw', aspectRatio: '1/1' }}
    />
    <Placeholder
      className="mb-1.5"
      loading
      type="rect"
      style={{ width: '100vw', height: '60px' }}
    />
    <Placeholder
      className="mb-1.5"
      loading
      type="rect"
      style={{ width: '100vw', aspectRatio: '1/1' }}
    />
    <div className="pl-5 pr-5 md:pl-[3.333vw] md:pr-[3.333vw]">
      <PDPChooseYourOptionsPlaceholder />
      <PDPProtectionPlanSelectorPlaceholder />
      <PDPAddToBagSectionPlaceholder />
      <PDPSellingAttributesPlaceholder />
      <PDPProductDescriptionPlaceholder className="mb-1.5" />
    </div>
  </div>
);

export default PDPMobilePlaceholder;
